import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetAccountGroupsRequestModel, GetAccountGroupsResponseModel } from "@/features/accounts/account-group/services/get-account-groups-model";

export class GetAccountGroupsApi {
  /**
   * 口座グループ一覧取得
   */
  public getAccountGroups = async (
    param: GetAccountGroupsRequestModel
  ): Promise<GetAccountGroupsResponseModel[]> => {
    const path = `/api/accountgroups`;
    const res = await ApiClient.instance.get<GetAccountGroupsResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
